import { FilmComponent } from "../FilmComponent/FilmComponent"
import { GalleryComponent2 } from "../Gallery/GalleryComponent2"
import { february2026Photos } from "../Gallery/LabPhotos/february2026/february2026Photos"
import video from "../../assets/labPhotos/february2026/video.mp4"

import "./LabText.scss"

export const February2026 = () => {
	return (
		<div className='june2025'>
			<h2 className='LabTitle'>Semestr 1</h2>
			<p className='LabText2'>
				Korzystanie ze sprzętu, który pozyskaliśmy w ramach Laboratorium
				Przyszłości umożliwiły poszerzenie naszych pomocy dydaktycznych. Dzięki
				posiadaniu drukarki 3D uczniowie projektowali i drukowali prezenty na
				Dzień Chłopaka, ozdoby świąteczne, pomoce na matematykę, korzystaliśmy
				także z długopisów 3D przy pomocy których uczniowie wykonywali dekoracje
				świąteczne, a także prezenty dla bliskich z okazji Świąt .
			</p>
			<p className='LabText2'>
				Uczniowie klasy siódmej ćwiczyli kręcenie filmików, na lekcji języka
				angielskiego. Uczniowie klasy ósmej nagrywali rozmówki w języku
				niemieckim.
			</p>
			<p className='LabText2'>
				Klocki Lego wykorzystywano na rewalidacji w klasach młodszych, uczniowie
				budowali budowle posługując się instrukcją, a także według własnego
				pomysłu. Z dużym zaangażowaniem uczniowie dokumentują wszelkie imprezy
				szkolne i klasowe.
			</p>
			<GalleryComponent2
				carouselId='june2025Photos'
				images={february2026Photos}
			/>
			<FilmComponent videoPath={video} />
		</div>
	)
}
